import { ReviewRecommendation } from "@omni/types/api/reviews/bff/shared/teviewRecommendation.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { formatNumber } from "@/utils/format";

type RecommendationProps = {
    recommendation: ReviewRecommendation;
};

export const Recommendation = ({ recommendation }: RecommendationProps) => {
    const { t } = useGranite();

    const reviewersCount =
        recommendation.wouldRecommend + recommendation.wouldNotRecommend;
    if (reviewersCount === 0) return null;

    const displayWouldRecommendPercentage = formatNumber(
        recommendation.wouldRecommend / reviewersCount,
        Config.getLocale(),
        {
            style: "percent"
        }
    );

    return (
        <section>
            <p className={cn("tw:text-sm tw:mb-0")}>
                {t(
                    "product.reviews.summary.recommendation",
                    recommendation.wouldRecommend,
                    reviewersCount,
                    displayWouldRecommendPercentage
                )}
            </p>
        </section>
    );
};
